/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tree = require("./tree");
var _default = function _default(data, arg) {
  var treeExpandData = (0, _tree.expandByIdsWithInfo)(data, arg);
  return treeExpandData.data;
};
exports.default = _default;